import {
  Menu,
  MenuItem,
  FormControlLabel,
  Divider,
  Grid2,
  IconButton,
  Tooltip,
  Checkbox,
  Collapse
} from "@mui/material";
import MaterialBox from "../../../../components/MaterialBox";
import MaterialTypography from "../../../../components/MaterialTypography";
import { ExpandMore, FilterAltOff } from "@mui/icons-material";
import { useState } from "react";
import { useSnackbar } from "../../../../context/popup";
import { useLoading } from "../../../../components/Loading";
import { fetchData } from "../../../../services";


const MotorVariantListFilter = ({ anchorEl, open, onClose, filterData, setFilterData, onApply }) => {

    const {setCircleLoading} = useLoading();
    const {showSnackbar} = useSnackbar();

    const sectionHeader = {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "2px 6px",
        background: "#e9ecf5",
        borderRadius: "6px",
        cursor: "pointer",
        mb: 0.5,
    };

    const menuItemStyle = {
        borderRadius: "6px",
        my: 0.2,
        mx: 0.5,
        py: 0.3,
        "&:hover": { backgroundColor: "#dfe6ff" },
    };

    const labelStyle = {
        m: 0,
        "& .MuiFormControlLabel-label": { fontSize: "0.8rem" },
    };

    //accordian states
    const [openActive, setOpenActive] = useState(false);
    const [openMotorCategory, setOpenMotorCategory] = useState(false);
    const [openMotorModel, setOpenMotorModel] = useState(false);
    const [openFuelType, setOpenFuelType] = useState(false);
    //option states
    const [motorCategoryOptions, setMotorCategoryOptions] = useState([]);
    const [motorModelOptions, setMotorModelOptions] = useState([]);
    const [fuelTypeOptions, setFuelTypeOptions] = useState([]);

    const fetchMotorCategoryList = async () => {
        setCircleLoading(true);
        try {
            const response = await fetchData(`/reference/general/key-value-store?dropdown=true&code=MO_CA`)

            if(response?.success){
                const formattedCountries = response?.data?.items?.map((item) => ({
                    value: item.id,
                    label: item.keyName,
                }));
                setMotorCategoryOptions(formattedCountries)
            }
            else{
                //throw error
                showSnackbar("Error Fetching Country List", "error")
            }
        } catch (error) {
            console.error('Error Fetching Countries:', error);
            showSnackbar("Error Fetching Country List", "error")
        }
        finally{
            setCircleLoading(false);
        }
    };

    const fetchMotorModelList = async () => {
        setCircleLoading(true);
        try {
            const response = await fetchData(`/reference/motor/mmv/models?dropdown=true&isActive=true`)

            if(response?.success){
                const formattedOptions = response?.data?.items?.map((item) => ({
                    value: item.id,
                    label: item.name,
                }));
                setMotorModelOptions(formattedOptions)
            }
            else{
                //throw error
                showSnackbar("Error Fetching Country List", "error")
            }
        } catch (error) {
            console.error('Error Fetching Countries:', error);
            showSnackbar("Error Fetching Country List", "error")
        }
        finally{
            setCircleLoading(false);
        }
    };

    const fetchFuelTypeList = async () => {
        setCircleLoading(true);
        try {
        const response = await fetchData(
            `/reference/motor/key-value-store?dropdown=true&&code=FU_TY&&isActive=true` //Fuel Type Category Dropdown
        );

        if (response?.success) {
            setFuelTypeOptions(
            response.data?.items?.map((item) => ({
                value: item.id,
                label: item.keyName,
            })) || []
            );
        } else {
            console.warn("Failed to fetch category dropdown data");
        }
        } catch (error) {
        console.error("Error fetching category dropdown:", error);
        } finally {
        setCircleLoading(false);
        }
    };
    
    const handleChange = ({ target: { name, value } }) => {
        setFilterData(prev => ({
            ...prev,
            [name]: value
        }));
    };


    const onClearFilters = () => {
        setFilterData({
            isActive: "",
            motorCategoryId: "",
            motorModelId: "",
            fuelTypeId: ""
        });
    };


  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      sx={{backgroundColor: "rgba(0, 0, 0, 0.3)",}}
      PaperProps={{
          elevation: 3,
          sx: {
            width: 250,
            padding: 1.5,
          },
      }}
    >
        <MaterialBox
        sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
        }}
        >
            {/* Title */}
            <MaterialTypography variant="body2" fontWeight="bold">
                Motor Variant Filter
            </MaterialTypography>

            {/* Clear Button */}
            <Tooltip title="Clear Filter" disableInteractive>
                <IconButton
                    size="small"
                    onClick={onClearFilters}
                    sx={{ color: "#ce0707ff" }}
                >
                    <FilterAltOff />
                </IconButton>
            </Tooltip>
        </MaterialBox>


      {/* Content */}
        <MaterialBox ml={1} mt={1} sx={{
        maxHeight: 300, 
        overflowY: "auto"}}>
            <Grid2 container spacing={1}>
                {/* Active Status */}
                <Grid2 size={{xs:12}}>
                    <MaterialBox>
                        <MaterialBox sx={sectionHeader} onClick={() => setOpenActive(!openActive)}>
                        <MaterialTypography variant="body3" fontWeight="bold">
                            Active Status
                        </MaterialTypography>

                        <IconButton size="small">
                            <ExpandMore
                            sx={{
                                transform: openActive ? "rotate(180deg)" : "rotate(0deg)",
                                transition: "0.2s",
                            }}
                            />
                        </IconButton>
                        </MaterialBox>

                        <Collapse in={openActive}>
                        <MenuItem
                            disableRipple
                            sx={menuItemStyle}
                            onClick={() =>
                            handleChange({
                                target: { name: "isActive", value: true },
                            })
                            }
                        >
                            <FormControlLabel
                            control={<Checkbox size="small" checked={filterData.isActive === true} />}
                            label="Active"
                            sx={labelStyle}
                            />
                        </MenuItem>

                        <MenuItem
                            disableRipple
                            sx={menuItemStyle}
                            onClick={() =>
                            handleChange({
                                target: { name: "isActive", value: false },
                            })
                            }
                        >
                            <FormControlLabel
                            control={<Checkbox size="small" checked={filterData.isActive === false} />}
                            label="Inactive"
                            sx={labelStyle}
                            />
                        </MenuItem>
                        </Collapse>
                    </MaterialBox>
                </Grid2>
                {/* Motor Category */}
                <Grid2 size={{xs:12}}>
                    <MaterialBox>
                        <MaterialBox sx={sectionHeader} onClick={() => {
                            const nextState = !openMotorCategory;
                            setOpenMotorCategory(nextState);

                            if (nextState && motorCategoryOptions.length === 0) {
                                fetchMotorCategoryList();
                            }
                        }}
                        >
                        <MaterialTypography variant="body3" fontWeight="bold">
                            Motor Category
                        </MaterialTypography>

                        <IconButton size="small">
                            <ExpandMore
                            sx={{
                                transform: openMotorCategory ? "rotate(180deg)" : "rotate(0deg)",
                                transition: "0.2s",
                            }}
                            />
                        </IconButton>
                        </MaterialBox>

                        <Collapse in={openMotorCategory}>
                        {motorCategoryOptions?.map((item) => (
                            <MenuItem
                            key={item.value}
                            disableRipple
                            sx={menuItemStyle}
                            onClick={() =>
                                handleChange({
                                target: { name: "motorCategoryId", value: item.value },
                                })
                            }
                            >
                            <FormControlLabel
                                control={<Checkbox size="small" checked={filterData.motorCategoryId === item.value} />}
                                label={item.label}
                                sx={labelStyle}
                            />
                            </MenuItem>
                        ))}
                        </Collapse>
                    </MaterialBox>
                </Grid2>
                {/* motor Model */}
                <Grid2 size={{xs:12}}>
                    <MaterialBox>
                        <MaterialBox sx={sectionHeader} onClick={() => {
                            const nextState = !openMotorModel;
                            setOpenMotorModel(nextState);

                            if (nextState && motorModelOptions.length === 0) {
                                fetchMotorModelList();
                            }
                        }}
                        >
                        <MaterialTypography variant="body3" fontWeight="bold">
                            Motor Model
                        </MaterialTypography>

                        <IconButton size="small">
                            <ExpandMore
                            sx={{
                                transform: openMotorModel ? "rotate(180deg)" : "rotate(0deg)",
                                transition: "0.2s",
                            }}
                            />
                        </IconButton>
                        </MaterialBox>

                        <Collapse in={openMotorModel}>
                        {motorModelOptions?.map((item) => (
                            <MenuItem
                            key={item.value}
                            disableRipple
                            sx={menuItemStyle}
                            onClick={() =>
                                handleChange({
                                target: { name: "motorModelId", value: item.value },
                                })
                            }
                            >
                            <FormControlLabel
                                control={<Checkbox size="small" checked={filterData.motorModelId === item.value} />}
                                label={item.label}
                                sx={labelStyle}
                            />
                            </MenuItem>
                        ))}
                        </Collapse>
                    </MaterialBox>
                </Grid2>
                {/* Fuel Type */}
                <Grid2 size={{xs:12}}>
                    <MaterialBox>
                        <MaterialBox sx={sectionHeader} onClick={() => {
                            const nextState = !openFuelType;
                            setOpenFuelType(nextState);

                            if (nextState && fuelTypeOptions.length === 0) {
                                fetchFuelTypeList();
                            }
                        }}
                        >
                        <MaterialTypography variant="body3" fontWeight="bold">
                            Fuel Type
                        </MaterialTypography>

                        <IconButton size="small">
                            <ExpandMore
                            sx={{
                                transform: openFuelType ? "rotate(180deg)" : "rotate(0deg)",
                                transition: "0.2s",
                            }}
                            />
                        </IconButton>
                        </MaterialBox>

                        <Collapse in={openFuelType}>
                        {fuelTypeOptions?.map((item) => (
                            <MenuItem
                            key={item.value}
                            disableRipple
                            sx={menuItemStyle}
                            onClick={() =>
                                handleChange({
                                target: { name: "fuelTypeId", value: item.value },
                                })
                            }
                            >
                            <FormControlLabel
                                control={<Checkbox size="small" checked={filterData.fuelTypeId === item.value} />}
                                label={item.label}
                                sx={labelStyle}
                            />
                            </MenuItem>
                        ))}
                        </Collapse>
                    </MaterialBox>
                </Grid2>
            </Grid2>

        </MaterialBox>

        <Divider />

        {/* Apply button */}
        <MenuItem
        onClick={() => onApply()}
        disableRipple
        sx={{
            padding: "6px 16px", 
            width: "fit-content",
            minWidth: "0px",
            mx: "auto",  
            borderRadius: "6px",
            backgroundColor: "#bcc7e9",
            color: "white",
            display: "flex",
            justifyContent: "center",
            transition: "0.2s ease",

            "&:hover": {
            backgroundColor: "#93a6e8",
            }
        }}
        >
        <MaterialTypography variant="button" fontWeight="bold">
            APPLY FILTER
        </MaterialTypography>
        </MenuItem>
    </Menu>
  );
};

export default MotorVariantListFilter;
